module.exports = __webpack_public_path__ + "static/media/pic15.6d16ca3a.jpg";